import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiError, api } from "@/lib/api";

// Resuelve un TE (ticket externo) a su folio y navega al caso. Lo usan los TE
// clicables de la narrativa y de la Sala de cierre.
export default function ResolverTE() {
  const { te } = useParams();
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!te) return;
    api
      .get<{ folio: string }>(`/api/casos/por-te/${encodeURIComponent(te)}`)
      .then((r) => nav(`/casos/${r.folio}`, { replace: true }))
      .catch((e) =>
        setError(e instanceof ApiError ? e.detail : "No encontré ese ticket"),
      );
  }, [te, nav]);

  return (
    <div className="card text-sm text-zinc-400">
      {error ? `${error} (TE ${te}).` : `Buscando el caso del ticket ${te}…`}
    </div>
  );
}
